import angular from 'angular';

angular.module('app.community').constant(
    'COMMUNITY',
    Object.freeze({
        menuCommunity: [
            {
                id: 'detail',
                order: 0,
                display: true,
                label: 'community.info.label',
                link: 'community.details.main',
                showOk: true,
            },
            {
                id: 'companies',
                order: 1,
                display: true,
                label: 'community.companies.title',
                link: 'community.details.companies',
                showOk: true,
            },
            {
                id: 'community-portal',
                order: 2,
                display: true,
                label: 'community.portal.label',
                link: 'community.details.portal',
                showOk: true,
            },
            {
                id: 'stock-software',
                order: 3,
                display: true,
                label: 'community.stock_software.label',
                link: 'community.details.stock-software-list',
                showOk: true,
            },
            {
                id: 'personalise-community',
                order: 4,
                display: true,
                label: 'community.personalise.label',
                link: 'community.details.personalise',
                showOk: true,
            },
            {
                id: 'groupement-community',
                order: 5,
                display: true,
                label: 'community.groupement.title',
                link: 'community.details.groupement-list',
                showOk: true,
            },

            {
                id: 'managing-referential',
                order: 6,
                display: true,
                label: 'community.referential.title',
                link: 'community.details.referential',
                showOk: true,
            },
            {
                id: 'managing-orders',
                order: 7,
                display: true,
                label: 'community.commandes.title',
                link: 'community.details.orders',
                showOk: true,
            },
            {
                id: 'managing-orders-response',
                order: 8,
                display: true,
                label: 'community.orders_response.title',
                link: 'community.details.orders-response',
                showOk: true,
            },
            {
                id: 'desadv-param',
                order: 9,
                display: true,
                label: 'community.desadv.title',
                link: 'community.details.desadvparam',
                showOk: true,
            },
        ],
    })
);
